// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"6c0c00c9","920":"82aa510b"}[chunkId] + ".chunk.css";
};